import React from "react";
import { Badge } from "antd";
import { MessageOutlined } from "@ant-design/icons";
import { useChat } from "./ChatContext";
import type { useLauncherDock } from "@/hooks/useLauncherDock";

/** Floating bubble for widget mode — inner slot of the shared launcher dock, next to CallWidget's FAB (see useLauncherDock). */
const ChatLauncher: React.FC<{
  fabProps: ReturnType<typeof useLauncherDock>["fabProps"];
  dragging: boolean;
}> = ({ fabProps, dragging }) => {
  const { open, toggleOpen, unreadTotal } = useChat();

  return (
    <div
      className={`chat-widget-fab${open ? " chat-widget-fab--active" : ""}${dragging ? " launcher-dock-fab--dragging" : ""}`}
      {...fabProps}
      onClick={toggleOpen}
    >
      <Badge count={unreadTotal} overflowCount={99} size="small">
        <MessageOutlined className="chat-widget-fab__icon" />
      </Badge>
    </div>
  );
};

export default ChatLauncher;
